import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import isEmail from "validator/lib/isEmail";
import SideSection from "../../components/sideContent/sideSection";
import renderHTML from "react-render-html";
import withStyles from "@material-ui/core/styles/withStyles";
import { useHistory } from "react-router-dom";
import { Box, Button, Typography, TextField } from "@material-ui/core";
import { useStyles } from "./indexStyles";
import { Images } from "../../constants/images";
import {
  buildLoginPayload,
  buildSystemError,
  isLoginNextButton,
} from "../../helpers/proposal";
import { postWebService } from "../../helpers/server";
import {
  getLendingRoute,
  parseMessage,
  setStorageItem,
} from "../../helpers/utils";
import { validations } from "../../messages/validation";

const Login = ({
  classes: {
    button,
    customBtn,
    errorMsg,
    formInput,
    formInputCard,
    imgLg,
    input,
    mobileInput,
    mobileInputFocus,
    mobileLabel,
    numberInputBox,
    subTitle,
    logoVShield,
  },
  classes,
}) => {
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({
    email: "",
    password: "",
    hasError: false,
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [onfocusMobile, setOnfocusMobile] = useState(false);
  const [touchFields, setTouchFields] = useState({
    email: false,
    password: false,
  });

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigateTo(getLendingRoute("dashboard"));
    }
  });

  useEffect(() => validateEmail(), [form.email]);

  useEffect(() => validatePassword(), [form.password]);

  const validateEmail = () => {
    if (form.email) {
      let isValid = isEmail(form.email, ["en-IN"]);
      setStateVariables(
        "email",
        isValid,
        isValid ? "" : validations.email.valid
      );
    } else if (touchFields.email) {
      setErrorMessageState("email", validations.email.required);
    }
  };

  const validatePassword = () => {
    if (form.password) {
      let isValid = form.password.length >= 4;
      setStateVariables(
        "password",
        isValid,
        isValid ? "" : validations.password.valid
      );
    } else if (touchFields.password) {
      setErrorMessageState("password", validations.password.required);
    }
  };

  const toggleClass = () => setOnfocusMobile(true);

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const handleChange = (event) => {
    setErrors([]);
    setFormState(event.target.name, event.target.value);
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const cbError = ({ data: { error_msg = "" }, message: msg = "" }) => {
    setIsFormSubmitted(false);
    const message = parseMessage(msg);
    if (Array.isArray(message)) {
      setErrors(message);
    } else {
      let messageArray = [];
      messageArray.push(message);
      setErrors(messageArray);
    }
  };

  const cbSuccess = ({
    token,
    name = "",
    service_centre_id = "",
    service_centre_user_id = "",
  } = {}) => {
    setErrors([]);
    setIsFormSubmitted(false);
    setStorageItem("token", token);
    setStorageItem(
      "user_details",
      JSON.stringify({ name, service_centre_id, service_centre_user_id })
    );
    navigateTo(getLendingRoute("dashboard"));
  };

  const submitLoginCredentials = async (event) => {
    setIsFormSubmitted(true);
    setErrors([]);
    try {
      const response = await postWebService(
        `user/login`,
        buildLoginPayload(form)
      );

      cbSuccess(response.data.data);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemError()
      );
    }
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();

    submitLoginCredentials();
  };

  return (
    <>
      <Box id="mainBlock">
        <SideSection
          onFocus={onfocusMobile}
          title={"Safety Verification"}
          description={
            <Typography variant={"body1"} className={subTitle}>
              For safety concerns, we need to validate your login credentials.
            </Typography>
          }
          image={<img src={Images.familyIllus} className={imgLg} alt="" />}
          data={
            <Box className={formInput}>
              <Box className={classes.logoHeader}>
                <Box>
                  <img
                    src={Images.vShield}
                    alt="Garantie"
                    className={logoVShield}
                  />
                  <Typography variant={"h3"} className={classes.textHeader}>
                    Service Centre <br />Platform
                  </Typography>
                </Box>
              </Box>
              <Box className={formInputCard}>
                <form
                  noValidate
                  autoComplete="off"
                  className={input}
                  onSubmit={onSubmitHandler}
                >
                  <Box className={numberInputBox}>
                    <Typography variant={"h6"} className={mobileLabel}>
                      Enter email and password
                    </Typography>
                    <TextField
                      id="standard-basic"
                      label={"Email"}
                      variant="standard"
                      value={form.email}
                      className={
                        !onfocusMobile ? mobileInput : mobileInputFocus
                      }
                      name="email"
                      onChange={handleChange}
                      onFocus={toggleClass}
                      autoComplete="off"
                      helperText={errorMessage.email}
                    />
                  </Box>

                  <Box className={numberInputBox}>
                    <TextField
                      type="password"
                      id="standard-basic"
                      label={"Password"}
                      variant="standard"
                      value={form.password}
                      className={
                        !onfocusMobile ? mobileInput : mobileInputFocus
                      }
                      name="password"
                      onChange={handleChange}
                      onFocus={toggleClass}
                      autoComplete="off"
                      helperText={errorMessage.password}
                    />
                  </Box>

                  {errors.length > 0 && (
                    <Box className={`mt-5`}>
                      {errors.map((item, index) => {
                        return (
                          <Typography
                            key={index}
                            className={`mb-5 ${errorMsg}`}
                            color={"primary"}
                            variant={"body2"}
                          >
                            {item}
                          </Typography>
                        );
                      })}
                    </Box>
                  )}

                  <Box className={customBtn}>
                    <Button
                      type="submit"
                      size="large"
                      variant={"contained"}
                      color="primary"
                      className={button}
                      {...((isFormSubmitted ||
                        isLoginNextButton(form, errorMessage)) && {
                        disabled: true,
                      })}
                    >
                      {!isFormSubmitted ? (
                        renderHTML("Submit")
                      ) : (
                        <CircularProgress
                          color={"inherit"}
                          className={classes.loaderStyle}
                          size={20}
                        />
                      )}
                    </Button>
                  </Box>
                </form>
              </Box>
            </Box>
          }
        />
      </Box>
    </>
  );
};

export default withStyles(useStyles, { withTheme: true })(Login);
